// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".decision_upload_file_field-module__block--iF0AR{background:#fff;border:2px dashed #e7ebef;width:100%;margin:0 0 1rem;text-align:center;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px}.decision_upload_file_field-module__text--3bWmQ{margin:1em;font-size:18px}.decision_upload_file_field-module__info--2QhQN{margin-bottom:10px;font-weight:500;font-size:12px;line-height:18px;letter-spacing:0}.decision_upload_file_field-module__infoLink--1uVzD{text-decoration:underline;cursor:pointer}.decision_upload_file_field-module__chooseButton--241Ty{color:#02b875}\n", ""]);
// Exports
exports.locals = {
	"block": "decision_upload_file_field-module__block--iF0AR",
	"text": "decision_upload_file_field-module__text--3bWmQ",
	"info": "decision_upload_file_field-module__info--2QhQN",
	"infoLink": "decision_upload_file_field-module__infoLink--1uVzD",
	"chooseButton": "decision_upload_file_field-module__chooseButton--241Ty"
};
module.exports = exports;
